import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "w-100 d-flex justify-content-between" }
const _hoisted_3 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_4 = { class: "card-body pt-9 pb-5" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex flex-wrap flex-sm-nowrap"
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-wrap flex-sm-nowrap"
}
const _hoisted_7 = { class: "me-7 mb-4" }
const _hoisted_8 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative img-thumbnail" }
const _hoisted_9 = { class: "image-slot" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-body h-20px w-20px" }, null, -1)
const _hoisted_11 = { class: "flex-grow-1" }
const _hoisted_12 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = { class: "d-flex align-items-center mb-2" }
const _hoisted_15 = {
  href: "#",
  class: "text-gray-900 text-hover-primary fs-2 fw-bold me-1"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-verify fs-1 text-primary" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
    /*#__PURE__*/_createElementVNode("span", { class: "path2" })
  ])
], -1)
const _hoisted_17 = { class: "d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2" }
const _hoisted_18 = {
  key: 0,
  href: "#",
  class: "d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2"
}
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<i class=\"ki-duotone ki-profile-circle fs-4 me-1\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span></i><span class=\"fa fa-envelope\"></span>", 2)
const _hoisted_21 = {
  key: 1,
  href: "#",
  class: "d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-profile-circle fs-4 me-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path3" })
], -1)
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-map-marker" }, null, -1)
const _hoisted_25 = {
  key: 2,
  href: "#",
  class: "d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-geolocation fs-4 me-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_27 = ["href"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-phone-alt" }, null, -1)
const _hoisted_29 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_30 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_31 = { class: "d-flex flex-wrap" }
const _hoisted_32 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_33 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-arrow-up fs-3 text-success me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_35 = {
  class: "fs-2 fw-bold counted text-center",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$",
  "data-kt-initialized": "1"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-gray-500 text-center" }, " Entries ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Chip = _resolveComponent("Chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Breadcrumb, { items: _ctx.breadcrumbs }, null, 8, ["items"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.member?.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_el_skeleton, {
                rows: 3,
                animated: ""
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_image, {
                    src: _ctx.member?.avatar_src,
                    class: "align-middle",
                    lazy: "",
                    fit: "contain"
                  }, {
                    error: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_icon_picture)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["src"]),
                  _hoisted_10
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("a", _hoisted_15, [
                        _createTextVNode(_toDisplayString(_ctx.member?.first_name) + " " + _toDisplayString(_ctx.member?.last_name) + " ", 1),
                        _createVNode(_component_Chip, {
                          type: _ctx.getStatus(_ctx.member).type,
                          text: _ctx.getStatus(_ctx.member).text
                        }, null, 8, ["type", "text"])
                      ]),
                      _hoisted_16
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      (_ctx.member?.email)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_18, [
                            _hoisted_19,
                            _createTextVNode("  " + _toDisplayString(_ctx.member?.email), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.address)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("a", {
                              href: `http://maps.google.com/maps?q=${_ctx.address}`,
                              target: "_blank",
                              rel: "noreferrer noopener"
                            }, [
                              _hoisted_24,
                              _createTextVNode(" " + _toDisplayString(_ctx.address), 1)
                            ], 8, _hoisted_23)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.member?.mobile_number)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_25, [
                            _hoisted_26,
                            _createElementVNode("a", {
                              href: `tel: ${_ctx.member?.mobile_number}`
                            }, [
                              _hoisted_28,
                              _createTextVNode(" " + _toDisplayString(_ctx.member?.mobile_number), 1)
                            ], 8, _hoisted_27)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.member.entries ? _ctx.member.entries : 0), 1)
                        ]),
                        _hoisted_36
                      ])
                    ])
                  ])
                ])
              ])
            ]))
      ])
    ])
  ]))
}